import { css } from '@emotion/react';
import type { ButtonHTMLAttributes } from 'react';

import IconInfoCircleOutline from '~icons/ci/info-circle-outline';

import { su, theme } from '@adflow/frontend/ui-theme';

import type { HubTooltipProps } from './HubTooltip';
import { HubTooltip } from './HubTooltip';

const styles = {
	container: (gray?: boolean) =>
		css(su.roundedFull, {
			color: gray ? theme.colors.text.hint : theme.colors.lightBlue,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			cursor: 'pointer',

			border: 'none',

			'&:hover': {
				border: 'none',
				color: gray
					? theme.colors.text.faint
					: theme.colors.palettes.primary.main,
			},
		}),
};

export interface InfoCircleProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	calloutText: HubTooltipProps['title'];
	tooltipProps?: Omit<HubTooltipProps, 'title' | 'children'>;
	size?: number;
	gray?: boolean;
}

export function InfoCircle(props: InfoCircleProps) {
	const { calloutText, size, tooltipProps, gray, ...buttonProps } = props;

	const sizeStyle = css({
		width: size ?? 20,
		height: size ?? 20,
	});

	return (
		<HubTooltip {...tooltipProps} title={calloutText}>
			<button
				type="button"
				data-cy="info-circle"
				css={[styles.container(gray), sizeStyle]}
				{...buttonProps}
			>
				<IconInfoCircleOutline css={sizeStyle} />
			</button>
		</HubTooltip>
	);
}
